import { WorkQueueDetails, WorkQueueState } from '@core/services/work-queue/work-queue.model';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRoot from '../../../features.state';
import * as lenderremediationqueueActions from './lender-remediation.actions';

export interface AppState extends fromRoot.FeaturesState {
  lenderremediationstate: WorkQueueState;
}

export const lenderRemediationAdapter: EntityAdapter<WorkQueueDetails> = createEntityAdapter<WorkQueueDetails>();

export const defaultLenderRemediation: WorkQueueState = {
  ids: [],
  entities: {},
  selectedId: null,
  loading: false,
  loaded: false,
  error: '',
};

export const initialState = lenderRemediationAdapter.getInitialState(defaultLenderRemediation);

export function LenderRemediationQueueReducer(
  state = initialState,
  action: lenderremediationqueueActions.LenderRemediationQueueAction
): WorkQueueState {
  switch (action.type) {
    case lenderremediationqueueActions.lenderRemediationQueueActionTypes.LOAD_LENDERREMEDIATIONQUEUE_SUCCESS: {
      return lenderRemediationAdapter.addOne(action.payload, {
        ...state,
        selectedId: action.payload.id,
      });
    }

    case lenderremediationqueueActions.lenderRemediationQueueActionTypes.LOAD_LENDERREMEDIATIONQUEUE_FAIL: {
      return {
        ...state,
        error: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}

const getLenderRemediationQueueState = createFeatureSelector<WorkQueueState>('confirmedQueue');

export const getLenderRemediationQueue = createSelector(
  getLenderRemediationQueueState,
  lenderRemediationAdapter.getSelectors().selectAll
);

export const getLenderRemediationQueueLoading = createSelector(
  getLenderRemediationQueueState,
  (state: WorkQueueState) => state.loading
);

export const getLenderRemediationQueueLoaded = createSelector(
  getLenderRemediationQueueState,
  (state: WorkQueueState) => state.loaded
);

export const getError = createSelector(
  getLenderRemediationQueueState,
  (state: WorkQueueState) => state.error
);

export const getCurrentLenderRemediationQueueId = createSelector(
  getLenderRemediationQueueState,
  (state: WorkQueueState) => state.selectedId
);

export const getCurrentLenderRemediationQueue = createSelector(
  getLenderRemediationQueueState,
  getCurrentLenderRemediationQueueId,
  state => state.entities[state.selectedId]
);
